<template>
  <div class="flex flex-wrap justify-center">
    <div
      v-for="curYouth in aviableYouths"
      :key="curYouth.key"
      class="flex justify-center mb-4 mr-4 cursor-pointer h-24 w-24
           primary-bg uppercase hover:bg-green-light text-white font-bold border-b-4 border-green-dark hover:border-green rounded shadow-lg"
      @click="onSelected(curYouth.key)"
    >
      <div class="text text-xl m-auto">
        {{ curYouth.key }}
      </div>
    </div>
  </div>
</template>

<script>
import apiService from './api/apiService'

export default {
    name: 'YouthSelector',
    props: {
        youth: {
            type: String,
            required: false,
            default: null
        }
    },

    data () {
        return {
            selectedYouth: null,
            aviableYouths: null
        }
    },
    async mounted () {
        await this.loadYouths()
    },
    methods: {
        async loadYouths () {
            const response = await apiService.getYouths()
            this.aviableYouths = response.data
        },
        onSelected: function (youth) {
            this.selectedYouth = youth

            this.$emit('selected', youth)
        }
    }
}
</script>

<style scoped>

</style>